// 月份列表
export const monthList = [
  {
    label: '一月',
    keyName: 'janTarget'
  },
  {
    label: '二月',
    keyName: 'febTarget'
  },
  {
    label: '三月',
    keyName: 'marTarget'
  },
  {
    label: '四月',
    keyName: 'aprTarget'
  },
  {
    label: '五月',
    keyName: 'mayTarget'
  },
  {
    label: '六月',
    keyName: 'junTarget'
  },
  {
    label: '七月',
    keyName: 'julTarget'
  },
  {
    label: '八月',
    keyName: 'augTarget'
  },
  {
    label: '九月',
    keyName: 'sepTarget'
  },
  {
    label: '十月',
    keyName: 'octTarget'
  },
  {
    label: '十一月',
    keyName: 'novTarget'
  },
  {
    label: '十二月',
    keyName: 'decTarget'
  },
]